import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCompareFinancingTypes } from './hooks/useCompareFinancingTypes';

export const CompareFinancingTypes = () => {
    const { values, subtitles } = useCompareFinancingTypes();

    return (
        <SimpleBars
            title={`Tipo de Financiamento da Produção`}
            values={values}
            subtitles={subtitles}
            height={320}
        />
    );
};
